import EmptyState from "ds/components/EmptyState";
import { EmptystateUsersColored } from "components/icons/generated";
import Button from "ds/components/Button";

type FlowsProjectDetailsRolesEmptyProps = {
  onManageRoles: () => void;
};

const FlowsProjectDetailsRolesEmpty = ({ onManageRoles }: FlowsProjectDetailsRolesEmptyProps) => {
  return (
    <EmptyState
      title="No roles assigned yet"
      caption="Grant roles to allow this project to manage resources in other spaces."
      icon={EmptystateUsersColored}
      announce
    >
      <Button variant="primary" onPress={onManageRoles}>
        Manage roles
      </Button>
    </EmptyState>
  );
};

export default FlowsProjectDetailsRolesEmpty;
